import GrabbableWindow from './GrabbableWindow.js';

export default class ColorPaletteBase {
  constructor(colorManager, selector) {
    this._colorManager = colorManager;
    colorManager.register(color => this._selectColor(color));

    this._elPalette = document.querySelector(selector);
    this._elColorList = this._elPalette.querySelector('.colorList');
    this._elTemplateColor = this._elPalette.querySelector('.templates .color');
    this._grabbableWindow = new GrabbableWindow(this._elPalette);
  }
  show(yes) {
    if(yes){
      this._elPalette.classList.remove('hidden');
    } else {
      this._elPalette.classList.add('hidden');
    }
  }
  _selectColor(color) {
    const rgba = color.join(',');
    let elColor = this._elColorList.firstElementChild;
    while(elColor) {
      if(elColor.getAttribute('data-rgba') === rgba) {
        elColor.classList.add('selected');
      } else {
        elColor.classList.remove('selected');
      }
      elColor = elColor.nextElementSibling;
    }
  }
  _colorMouseUpHandler(e) {
    const elColor = e.currentTarget;
    const rgba = elColor.getAttribute('data-rgba');
    const color = rgba.split(',').map(v => Number(v));
    this._colorManager.set(color);
  }
}
